import {PLAY_HEADER_VIDEO, PLAY_LESSON_VIDEO, PAUSE_HEADER_VIDEO, PAUSE_LESSON_VIDEO} from './type';

export const playHeaderVideo = (play: boolean) => {
    // @ts-ignore
    return dispatch => {
        dispatch({
            type: PLAY_HEADER_VIDEO,
            payload: play,
        });
    }
};

export const pauseHeaderVideo = (pause: boolean) => {
    // @ts-ignore
    return dispatch => {
        dispatch({
            type: PAUSE_HEADER_VIDEO,
            payload: pause,
        });
    }
};

export const playLessonVideo = (play: boolean) => {
    // @ts-ignore
    return dispatch => {
        dispatch({
            type: PLAY_LESSON_VIDEO,
            payload: play,
        });
    }
};

export const pauseLessonVideo = (pause: boolean) => {
    // @ts-ignore
    return dispatch => {
        dispatch({
            type: PAUSE_LESSON_VIDEO,
            payload: pause,
        });
    }
};
